const tokenId = 'session-id'

export const setToken = (token: string) => localStorage.setItem(tokenId, token)

export const getToken = () => localStorage.getItem(tokenId)
